import React, { ReactNode } from 'react';
import { OfferInfoSummary, OfferInfoHeader } from '@applicant-flow/components';
import { HistoryDropDown, Gutter } from '@common/components';
import { ApplicationFromOfferInfoType } from '@applicant-flow/types';
import { OfferInfoDetails } from './_offer-info-details';
import {
  OfferChangeRequestType,
  OfferConfirmationType,
} from '@applicant-flow/graphql/';
import { ExtensionOfferPreviewType } from '@working-experience/graphql';

type OfferType = OfferConfirmationType | ExtensionOfferPreviewType;

export function OfferInfo({
  offer,
  headerSlot,
  footerSlot,
  application,
}: {
  offer: OfferType;
  headerSlot?: ReactNode;
  footerSlot?: ReactNode;
  application: ApplicationFromOfferInfoType;
}) {
  const { offerChangeRequests } = offer || {};
  const rate = offer?.billingRegularRate?.toFixed(2);

  const offerChangeRequest = getLastChangeRequest(offerChangeRequests);

  const oldBillingRegularRate = getOldBillingRegularRate(offerChangeRequest);

  const oldRate = oldBillingRegularRate?.toFixed(2);

  return (
    <>
      <div className="offer-info-body">
        <OfferInfoHeader
          candidateFullName={application.worksProfile?.fullName || ''}
          headerSlot={headerSlot}
          offer={{
            state: offer.state,
            stateChangedAt: offer.stateChangedAt,
            rejectionReason: offer.rejectionReason,
            rejectionDetails: offer.rejectionDetails,
          }}
        />
        <OfferInfoSummary
          application={application}
          rate={rate}
          oldRate={oldRate}
        />
        <OfferInfoDetails
          offerChangeRequests={offerChangeRequests}
          startDate={offer.startDate}
          endDate={offer.endDate}
          shiftType={offer.shiftType}
          shiftsPerWeek={offer.shiftsPerWeek}
          hoursPerShift={offer.hoursPerShift}
          overtimeThreshold={offer.overtimeThreshold}
          timeoffDescription={offer.timeoffDescription}
        />
      </div>
      {footerSlot && <div className="offer-info-footer-slot">{footerSlot}</div>}
      {offer?.history && (
        <Gutter direction="top" size="md">
          <HistoryDropDown data={offer?.history} />
        </Gutter>
      )}
    </>
  );
}

function getLastChangeRequest(
  offerChangeRequests?: OfferChangeRequestType[] | null
) {
  return offerChangeRequests?.length
    ? offerChangeRequests[offerChangeRequests.length - 1]
    : null;
}

function getOldBillingRegularRate(
  offerChangeRequest?: OfferChangeRequestType | null
) {
  const detail = offerChangeRequest?.offerChangeResponse?.detail;

  if (!detail || detail.__typename !== 'OfferAcceptanceResponseDetail') {
    return undefined;
  }

  return detail.oldBillingRegularRate;
}
